export default {
    TYPE_TRAVEL: 1,
    TYPE_SEMINAR: 2,
    TYPE_APPOINTMENT: 3,
    TYPE_EVENT: 4
}
